import { Link } from 'react-router-dom'

const EmployeeHeader = (props) => {
  return (
    <div className='header_container'>
    </div>
  );
}
export default EmployeeHeader;